import type { ReactNode } from "react";

/**
 * The action sits at the right end, where the eye leaves the strip. `leading` is for a field that
 * qualifies it - a periode picker - which stays on the left where reading starts.
 */
export function Toolbar({
  leading,
  children,
}: {
  leading?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="mb-4 flex flex-wrap items-center justify-end gap-2">
      {leading && <div className="me-auto">{leading}</div>}
      {children}
    </div>
  );
}
